import { Children, cloneElement } from 'react';

export const renderChildrenWithProps = (children, props) => {
  return Children.map(
    // remove null item
    Children.toArray(children).filter(Boolean),
    item => cloneElement(item, props),
  );
};
